import { Box, Typography } from "@mui/material";
import { ValGolf } from "./valGolf/ValGolf";

export function ValSimpleCompetitionV1() {
  return (
    <Box sx={{ width: "100%" }}>
      <ValGolf />
    </Box>
  );
}

export function ValSimpleCompetitionV2() {
  return <Box><Typography>Val V2 Placeholder</Typography></Box>;
}

export function ValSimpleCompetitionV3() {
  return <Box><Typography>Val V3 Placeholder</Typography></Box>;
}
